/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OperatoreComuneCompactDTO { 
    id?: string;
    email?: string;
    nome?: string;
    cognome?: string;
    account_enabled?: boolean;
    account_activated?: boolean;
    invito_in_attesa?: boolean;
    numero_comuni_gestiti?: number;
}

